import hu from './hu';

const translationsObject = {
  hu,
};

export default translationsObject;



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/locales/locales.js